import React from 'react';
import GoogleMap from './GoogleMap';

export interface Coordinate {
  lat: number;
  lng: number;
  count: number;
}

export interface LocationViewerProp {
  coordinates: Coordinate[];
}

function LocationViewer({ coordinates }: LocationViewerProp) {
  return (
    <div>
      <h1>Localização das infrações:</h1>
      <GoogleMap coordinates={coordinates} />
    </div>
  )
}

export default LocationViewer
